import { useBooleanState } from '@calendly/hooks'
import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { UserSingleIcon } from '@calendly/ui/components/icons'
import { colorTextSecondary } from '@calendly/ui/theme'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { fetchStatistics, statisticsSelector } from 'features/organization_statistics'

import { getTileTitle } from './helpers'
import { PendingUsersModal } from './pending_users_modal'
import { LoadingTile } from '../../components/loading_tile'
import { Tile } from '../../components/tile'


// i18n-tasks-use t('publisher.admin.dashboard.section.users.card.pending_users.title')
// i18n-tasks-use t('publisher.admin.dashboard.section.users.card.pending_users.empty_state')
export const PendingUsersTile = () => {
  const dispatch = useDispatch()
  const { invitations, isLoading } = useSelector(statisticsSelector)
  const [isModalOpen, openModal, closeModal] = useBooleanState(false)

  const isEmpty = invitations === 0
  const title = getTileTitle({ tileType: 'pending_users', count: invitations })

  useEffect(() => {
    if (invitations === null) dispatch(fetchStatistics())
  }, [dispatch, invitations])

  if (isLoading) return <LoadingTile />

  return (
    <>
      <Tile
        componentName="pending-users"
        icon={<UserSingleIcon color={colorTextSecondary} />}
        name={title}
        rightControls={!isEmpty && (
          <Button onClick={openModal} decoration="outline" responsive={false} size="small">
            {I18n.t('publisher.admin.dashboard.section.users.button.view_pending_users')}
          </Button>
        )}
      />
      {!isEmpty && (<PendingUsersModal isOpen={isModalOpen} onClose={closeModal} />)}
    </>
  )
}
